module.exports = __webpack_public_path__ + "img/rtdtrack.ef4ffe3b.jpg";